import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  // The overlay is only rendered when the org has approved templates, so every
  // access has to be guarded — Escape reaches this controller either way.
  open() {
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close() {
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  // Close on Escape key
  connect() {
    this.handleKeydown = (e) => {
      if (e.key === "Escape") this.close()
    }
    document.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
    document.body.style.overflow = ""
  }
}
